import CreditCard from '@components/shared/CreditCard/CreditCard'

/**
 * 
 * @param {BillingViewModel} vm
 * @returns {JSX.Element}
 * @constructor
 */
const BillingCards = ({
    vm,
}) => {
    
    return (<>
        
        <div className="flex justify-between items-center gap-2">
            <h4>Cards on File</h4>
            <button
                className="btn btn-primary btn-sm ml-3"
                onClick={() => vm.setAddPaymentCardDialogOpen(true)}>
                Add Card
            </button>
        </div>
        
        {/* <div className="p-4">
            <pre><code>{JSON.stringify(vm.stripeCards, null, 4)}</code></pre>
        </div> */}
        
        {!vm.loading && (
            !vm.stripeCards?.length ? (
                <div className="alert alert-warning block" role="alert">
                    <p>You do not have any credit cards on file yet.</p>
                </div>
            ) : (
                <div>
                    {vm.stripeCards?.map(card => (
                        <CreditCard
                            key={card.id}
                            className="float-left mr-4 mb-4"
                            {...card}
                            onRemoveCardClick={() => vm.onRemoveCardClick(card)} />
                    ))}
                </div>
            )
        )}
    
    </>)
    
}

export default BillingCards
